import { createRouter, createWebHistory } from "@ionic/vue-router";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { Storage } from "@capacitor/storage";
import Register from "../auth/register.vue";
import Login from "../auth/login.vue";
import Profile from "../views/components/profile";
import Home from "../views/components/homePage.vue";
import LegalTerms from "../views/components/legalTerms";
import Chatroom from "../views/components/chatRoom";
import createReads from "../views/reads/readsCreate";
import allComments from "../views/components/allComments.vue";
import FriendRequest from "../views/components/profile/friendRequest";
import notifications from "../views/notifications.vue";
import showallstories from "../views/reads/showStoryPage";
import stories from "../views/skeleton/index";
const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    component: Login,
    meta: { hideForAuth: true },
  },
  {
    path: "/register",
    component: Register,
    meta: { hideForAuth: true },
  },
  {
    path: "/legal_terms_of_service_and_agreement",
    component: LegalTerms,
  },
  {
    path: "/chatroom",
    component: Chatroom,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/profile/:id",
    component: Profile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/friend_request/:id",
    component: FriendRequest,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/story/read/create",
    component: createReads,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/notifications",
    component: notifications,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/stories/reads",
    component: showallstories,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/story/:id/",
    component: stories,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/post/:id",
    component: allComments,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  Storage.get({
    key: "user",
  }).then((response) => {
    const loggedIn = JSON.parse(response.value);
    const isAuth = to.matched.some((record) => record.meta.requiresAuth);
    const isHide = to.matched.some((record) => record.meta.hideForAuth);

    if (isAuth && !loggedIn) {
      return next({ path: "/login" });
    } else if (isHide && loggedIn) {
      return next({ path: "/home" });
    }
    next();
  });
});
export default router;
